import React from 'react';

const displayNoneTime = 0.3; //seconds

const ExpandHOC = (WrappedComponent) => {
  class Wrapper extends React.Component {
    constructor() {
      super();
      this.state = {
        isOpen: false,
        maxHeight: null,
        isDisplayNone: true,
      };
    }

    componentDidUpdate(prevProps, prevState) {
      let { isOpen: prevIsOpen } = prevState;
      let { isOpen } = this.state;

      // component was opened
      if (isOpen && !prevIsOpen) {
        this.setState({ maxHeight: this.expander.scrollHeight });
      }
    }

    toggleOpen = (event) => {
      let newState = {
        isOpen: !this.state.isOpen,
      };

      if (newState.isOpen) {
        newState.isDisplayNone = false;
        newState.maxHeight = 0;
      } else {
        setTimeout(
          () => this.setState({ isDisplayNone: true }),
          displayNoneTime * 1000
        );
      }

      this.setState(newState);
    };

    setRef = (elem) => {
      this.expander = elem;
    };

    render() {
      let passthroughProps = {
        ...this.props,
        toggleOpen: this.toggleOpen,
        setRef: this.setRef,
        maxHeight: this.state.maxHeight,
        isOpen: this.state.isOpen,
        isDisplayNone: this.state.isDisplayNone,
      };

      return <WrappedComponent {...passthroughProps} />;
    }
  }

  return Wrapper;
};

export default ExpandHOC;
